module.exports = __webpack_public_path__ + "img/2.e8deee92.png";